<template>
  <AppTileSpecieSkeleton>
    <div class="flex items-center gap-2 mb-4">
      <USkeleton class="h-7 w-40" />
      <USkeleton class="h-7 w-20" />
    </div>
    <ul class="flex flex-col items-start space-y-3">
      <li><USkeleton class="h-5.5 w-40" /></li>
      <li><USkeleton class="h-5.5 w-60" /></li>
    </ul>
  </AppTileSpecieSkeleton>
</template>
